import { Route, Routes } from "react-router-dom";

import {
  FraudsAndRisks,
  Invoices,
  PaymentLinks,
  Payments,
  Subscriptions,
  Transactions,
} from "../../pages";

export const PaymentsLayout = () => {
  return (
    <Routes>

      <Route path="/" element={<Payments />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/invoices" element={<Invoices />} />
      <Route path="/frauds" element={<FraudsAndRisks />} />
      <Route path="/payment-links" element={<PaymentLinks />} />
      <Route path="/subscriptions" element={<Subscriptions />} />
    </Routes>
  );
};
